/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Final_Cta_PrimaryInputs */

const en_dr_final_cta_primary = /** @type {(inputs: Dr_Final_Cta_PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start a free room`)
};

const id_dr_final_cta_primary = /** @type {(inputs: Dr_Final_Cta_PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mulai ruang gratis`)
};

/**
* | output |
* | --- |
* | "Start a free room" |
*
* @param {Dr_Final_Cta_PrimaryInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_final_cta_primary = /** @type {((inputs?: Dr_Final_Cta_PrimaryInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Final_Cta_PrimaryInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_final_cta_primary(inputs)
	return en_dr_final_cta_primary(inputs)
});